import { TrText } from "../components/TrText";
import { TrSpace } from "../components/TrSpace";
import { TrTextField } from "../components/TrTextField";
import { FormPageButton } from "../components/FormPageButton";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useCallback } from "react";
import { setBookInfo } from "../reducks/orders/operations";

export const BookSettings = () => {
    const dispatch = useDispatch();

    const [bookTitle, setBookTitle] = useState("")
    const [author, setAuthor] = useState("")
    const [isAlertForTitle, setIsAlertForTitle] = useState(false);
    const [isAlertForAuthor, setIsAlertForAuthor] = useState(false);

    const inputBookTitle = useCallback((event) => {
        setBookTitle(event.target.value);
    }, [setBookTitle])

    const inputAuthor = useCallback((event) => {
        setAuthor(event.target.value);
    }, [setAuthor])

    function checkValidate() {
        if(bookTitle === "") {
            setIsAlertForTitle(true);
        }else{
            setIsAlertForTitle(false); 
        }

        if(author === "") {
            setIsAlertForAuthor(true);
        }else{
            setIsAlertForAuthor(false);
        }
    }

    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>本のタイトルと著者名を設定</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                            <tbody>
                                <TrText text="本のタイトル"/>
                                <TrTextField id="book-title" placeholder="本のタイトル（必須）" isAlert={isAlertForTitle} onChange={inputBookTitle}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="著者名"/>
                                <TrTextField id="author-name" placeholder="著者名（必須）" isAlert={isAlertForAuthor} onChange={inputAuthor}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <FormPageButton 
                            text="次へ進む" 
                            onClick={() => {
                                checkValidate();
                                dispatch(setBookInfo(bookTitle, author));
                            }}
                        />
                    </div>
                </main>
        </div>
    );
};